import { RootStoreContext } from "../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { LoginForm } from "./forms/LoginForm";
import { LoginAlternativeForm } from "./forms/LoginAlternativeForm";
import RegisterForm from "./forms/RegisterForm";
import { ResetPwdForm } from "./forms/ResetPwdForm";
import LoginCustom2FactorForm from "./forms/LoginCustom2FactorForm";
import { LoginType } from "../app/models/company";
import LoginAuthenticatorAppForm from "./forms/LoginAuthenticatorAppForm";

const AuthContainer = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    showDefaultLogin,
    showAlternativeLogin,
    showRegister,
    showResetPwd,
  } = rootStore.authStore;
  const { company } = rootStore.commonStore;

  const renderLoginComponent = (type: string) => {
    switch (type) {
      case LoginType.owasp:
        return <LoginForm />;
      case LoginType.otp:
        return <LoginAlternativeForm />;
        case  LoginType.custom2factor:
        return <LoginCustom2FactorForm />;
        case LoginType.authenticatorapp:
        return <LoginAuthenticatorAppForm />;
      default:
        return <LoginForm />;
    }
  };

  if (company) {
    if (showDefaultLogin ){
      if(company.disabledCustom2FactorForSubnet)
        renderLoginComponent("owasp")
      else
      return renderLoginComponent(company!.defaultLoginMethod);
    }
    
    if (showAlternativeLogin){
      return renderLoginComponent(company!.alternativeLoginMethod);
    }
  }

  if (showRegister) return <RegisterForm />;

  if (showResetPwd) return <ResetPwdForm />;

  return <LoginForm />;
};

export default observer(AuthContainer);
